export default function testImage(url, timeout = 2000) {
	return new Promise((resolve) => {
		function fulfill(result) {
			if (isResolved) {
				return;
			}

			isResolved = true;
			resolve(result);
		}

		let isResolved = false;

		setTimeout(() => fulfill(false), timeout);

		const img = new Image();
		img.onload = () => fulfill(true);
		img.onerror = () => fulfill(false);
		img.src = url;
	});
}
